'use client';

const defaultProps = {
  a11yLabel: "Loading",
  size: "md"
};
export {
  defaultProps
};
